import { useContext } from 'preact/hooks';
import { PublisherStylingContext } from './publisherStylingProvider';

export const usePublisherStyling = () => {
  return useContext(PublisherStylingContext);
};
